import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0021',
    ecrans: ['00-2']
});
